export function init (element: HTMLElement) {
  const name = element.dataset.name;
  const domain = element.dataset.domain;
  const a = document.createElement('a');
  let link = 'mailto:' + name + '@' + domain;
  if (element.dataset.subject && element.dataset.subject.trim() !== '') {
    link += '?subject=' + encodeURIComponent(element.dataset.subject);
  }
  a.setAttribute('href', link);
  a.innerText = name + "@" + domain;
  element.parentElement.replaceChild(a, element);
}
